import React, { createContext, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const PageTransitionContext = createContext();

export const usePageTransition = () => {
  const context = useContext(PageTransitionContext);
  if (!context) {
    throw new Error('usePageTransition must be used within PageTransitionProvider');
  }
  return context;
};

export const PageTransitionProvider = ({ children }) => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const navigate = useNavigate();

  const navigateWithTransition = useCallback((to, options = {}) => {
    setIsTransitioning(true);
    
    // Wait for fade out, then navigate
    setTimeout(() => {
      // Scroll to top before navigation (while screen is dark)
      window.scrollTo(0, 0);
      
      navigate(to, options);
      
      // Small delay then fade back in
      setTimeout(() => {
        setIsTransitioning(false);
      }, 100);
    }, 400); // Match the CSS transition duration
  }, [navigate]);

  return (
    <PageTransitionContext.Provider value={{ isTransitioning, navigateWithTransition }}>
      {children}
      {/* Fade overlay */}
      <div className={`page-fade-overlay ${isTransitioning ? 'fade-active' : ''}`} />
    </PageTransitionContext.Provider>
  );
};

// Custom Link component with fade transition
export const TransitionLink = ({ to, children, className, onClick, state, ...props }) => {
  const { navigateWithTransition } = usePageTransition();

  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) onClick(e);
    navigateWithTransition(to, { state });
  };

  return (
    <a href={to} onClick={handleClick} className={className} {...props}>
      {children}
    </a>
  );
};
